import { SubscribeView } from 'Views/newsletter/subscription/SubscriptionView';
export default SubscribeView;
